// extracted by mini-css-extract-plugin
export default {"background":"specialize_background__6WucY","wrapper":"specialize_wrapper__SnhpY","title":"specialize_title__xNcN5"};